module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic10.c28bdd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic10.png
// module id = 475
// module chunks = 1